import React from "react";
import { parseISO } from "date-fns";

const PersonalDetailsSection = ({
  selectedMember,
  applicant,
  showPersonalDetails,
  setShowPersonalDetails,
  handleEditClick,
}) => {
  return (
    <div className="mb-4">
      <div
        className="d-flex align-items-center mb-3"
        style={{ cursor: "pointer" }}
        onClick={() => setShowPersonalDetails(!showPersonalDetails)}
      >
        <span
          style={{
            color: "#e91e63",
            fontSize: "14px",
            fontWeight: "600",
            marginRight: "8px",
          }}
        >
          Personal
        </span>
        <i
          className={`fas fa-chevron-${showPersonalDetails ? "down" : "right"}`}
          style={{ color: "#e91e63", fontSize: "12px" }}
        ></i>
      </div>

      {showPersonalDetails && (
        <div className="[ details-section ] [ mb-3 ]">
          <div className="[ row ] [ details-section__header">
            <div className="[ col-12 ]">
              <h3 className="[ d-flex justify-content-between align-items-center ]">
                PERSONAL DETAILS
                <button
                  type="button"
                  className="[ btn edit-btn ]"
                  aria-label="edit"
                  onClick={handleEditClick}
                >
                  <span className="[ edit-icon ]"></span>
                  <span className="[ edit-btn__label ]">Edit</span>
                </button>
              </h3>
            </div>
          </div>
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-6 ] [ details-section__item-label ]">
              First name:
            </div>
            <div className="[ col-6 ] [ details-section__item-description ]">
              {applicant?.member?.name ||
                (applicant?.member ? "—" : selectedMember?.firstName) ||
                "—"}
            </div>
          </div>
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-6 ] [ details-section__item-label ]">
              Middle name:
            </div>
            <div className="[ col-6 ] [ details-section__item-description ]">
              {applicant?.member?.middleName ||
                (applicant?.member ? "—" : selectedMember?.middleName) ||
                "—"}
            </div>
          </div>
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-6 ] [ details-section__item-label ]">
              Last name:
            </div>
            <div className="[ col-6 ] [ details-section__item-description ]">
              {applicant?.member?.surname ||
                (applicant?.member ? "—" : selectedMember?.lastName) ||
                "—"}
            </div>
          </div>
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-6 ] [ details-section__item-label ]">
              Date of birth:
            </div>
            <div className="[ col-6 ] [ details-section__item-description ]">
              {applicant?.member?.dob
                ? parseISO(applicant.member.dob).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })
                : applicant?.member
                ? "—"
                : selectedMember?.dateOfBirth
                ? parseISO(selectedMember.dateOfBirth).toLocaleDateString(
                    "en-US",
                    {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    }
                  )
                : "—"}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PersonalDetailsSection;
